<template>
  <DataComboBox v-model="pageId" :config="config" />
</template>

<script>
import DataComboBox from "../controls/DataComboBox.vue";

export default {
  name: "PagePicker",

  components: { DataComboBox },

  props: ["value", "title", "isRequired"],

  data() {
    return {
      pageId: 0,
      config: {
        title: this.title,
        listDataSource: "pages/query",
        listTextField: "name",
        listValueField: "name",
        isRequired: this.isRequired
      }
    };
  },

  watch: {
    value(v) {
      this.pageId = v;
    },
    pageId(v) {
      this.$emit("input", v);
    }
  },

  mounted() {
    this.pageId = this.value;
  }
};
</script>
